export default "./images/survio-cx806-assets-meta.png";